// extracted by mini-css-extract-plugin
export default {"wrapper":"HeaderCartButton_wrapper__yfTUu","textDiv":"HeaderCartButton_textDiv__WM+uP","floatingContentWrapper":"HeaderCartButton_floatingContentWrapper__-Nzn4"};